import { createSelector } from '@ngrx/store';
import { BoelsState, getStoreState } from '../../reducers.index';
import { GlobalProductSearchState } from '../reducers/global-product-search.reducer';

export const selectGlobalProductSearchPageState = createSelector(
  getStoreState,
  (state: BoelsState) => state.globalProductSearchState,
);

export const selectGlobalProductSearchPageEntities = createSelector(
  selectGlobalProductSearchPageState,
  (state: GlobalProductSearchState) => state.entities,
);

export const selectGlobalProductSearchPageTotalResults = createSelector(
  selectGlobalProductSearchPageState,
  (state: GlobalProductSearchState) => state.entities?.pagination?.totalResults,
);

export const selectGlobalProductSearchPageQueryTerm = createSelector(
  selectGlobalProductSearchPageState,
  (state: GlobalProductSearchState) => state.entities?.freeTextSearch,
);
